import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import TeamUpskill from "./index";
import { FaGraduationCap, FaMagnifyingGlass } from "react-icons/fa6";

const teamUpskillRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Upskill Your Team",
        basePath: "team-upskill",
        mainComponent: <TeamUpskill/>,
        layout: "/console",
        icon: <FaGraduationCap className="icon-item" />,
        subTitle:"Upskill Your Team",
        level:5,
        moduleId: 0,
    })
]

export default teamUpskillRoutes;